import { useCssModule, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
const spinner = "_spinner_org9d_1";
const isVerticalAligned = "_isVerticalAligned_org9d_7";
const spinnerIcon = "_spinnerIcon_org9d_10";
const spin = "_spin_org9d_1";
const fade = "_fade_org9d_1";
const style0 = {
  spinner,
  isVerticalAligned,
  spinnerIcon,
  spin,
  fade
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XSpinner",
  components: { XIcon }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "large"].includes(value)
    },
    variant: {
      type: String,
      default: "primary",
      validator: (value) => ["primary", "light", "dark"].includes(value)
    },
    vertical: {
      type: Boolean,
      default: false
    },
    showText: {
      type: Boolean,
      default: false
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const sizes = {
      small: "sm",
      medium: "xl",
      large: "2x"
    };
    const variantColors = {
      primary: "--color-brand-primary-400",
      light: "--color-neutral-0",
      dark: "--color-brand-primary-600"
    };
    const $style = useCssModule();
    const { t } = useI18n();
    const { formatTestId } = setupTestId(props);
    const innerSize = computed(() => sizes[props.size]);
    const spinnerStyle = computed(() => ({
      "--spinner-color": `var(${variantColors[props.variant]})`
    }));
    const verticalClass = computed(() => ({
      [$style.isVerticalAligned]: props.vertical
    }));
    return { __sfc: true, createTestIdProp, setupTestId, sizes, variantColors, props, $style, t, formatTestId, innerSize, spinnerStyle, verticalClass, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: [_setup.$style.spinner, _setup.verticalClass], style: _setup.spinnerStyle, attrs: { "role": "alert", "aria-busy": "true", "aria-live": "polite", "aria-describedby": "spinnerText", "data-testid": _setup.formatTestId() } }, [_c(_setup.XIcon, { class: _setup.$style.spinnerIcon, attrs: { "icon": "spinner", "icon-style": "fak", "aria-hidden": "true", "size": _setup.innerSize, "data-testid": _setup.formatTestId("icon") } }), _c("span", { directives: [{ name: "show", rawName: "v-show", value: _vm.showText, expression: "showText" }], attrs: { "id": "spinnerText", "aria-hidden": "true", "data-testid": _setup.formatTestId("text") } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_setup.t("ds.xSpinner.loading")))];
  })], 2)], 1);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XSpinner = __component__.exports;
export {
  XSpinner as default
};
